const icons = [
  'adjustments',
  'alarmclock',
  'anchor',
  'aperture',
  'attachment',
  'bargraph',
  'basket',
  'beaker',
  'bike',
  'book-open',
  'briefcase',
  'browser',
  'calendar',
  'camera',
  'caution',
  'chat',
  'circle-compass',
  'clipboard',
  'clock',
  'cloud',
  'compass',
  'desktop',
  'dial',
  'document',
  'documents',
  'download',
  'dribbble',
  'edit',
  'envelope',
  'expand',
  'facebook',
  'flag',
  'focus',
  'gears',
  'genius',
  'gift',
  'global',
  'globe',
  'googleplus',
  'grid',
  'happy',
  'hazardous',
  'heart',
  'hotairballoon',
  'hourglass',
  'key',
  'laptop',
  'layers',
  'lifesaver',
  'lightbulb',
  'linegraph',
  'linkedin',
  'lock',
  'magnifying-glass',
  'map',
  'map-pin',
  'megaphone',
  'mic',
  'mobile',
  'newspaper',
  'notebook',
  'paintbrush',
  'paperclip',
  'pencil',
  'phone',
  'picture',
  'pictures',
  'piechart',
  'presentation',
  'pricetags',
  'printer',
  'profile-female',
  'profile-male',
  'puzzle',
  'quote',
  'recycle',
  'refresh',
  'ribbon',
  'rss',
  'sad',
  'scissors',
  'scope',
  'search',
  'shield',
  'speedometer',
  'strategy',
  'streetsign',
  'tablet',
  'target',
  'telescope',
  'toolbox',
  'tools',
  'tools-2',
  'trophy',
  'tumblr',
  'twitter',
  'upload',
  'video',
  'wallet',
  'wine'];


export default icons;


/** WEBPACK FOOTER **
 ** ./frontend/components/modals/icons.jsx
 **/